var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg009User1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6C37;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471.4,325c-17-14.9-37.5-27.8-61.2-38.3c-10.1-4.5-21.9,0.1-26.4,10.2s0.1,21.9,10.2,26.4 c19.9,8.9,37.1,19.5,51,31.8c17.2,15.1,27,36.9,27,59.9v37c0,11-9,20-20,20H60c-11,0-20-9-20-20v-37c0-23,9.8-44.9,27-59.9 c20.2-17.8,79.1-59.1,189-59.1c81.6,0,148-66.4,148-148S337.6,0,256,0S108,66.4,108,148c0,47.7,22.7,90.2,57.9,117.3 C101.5,279.4,61.5,306.6,40.6,325C14.8,347.7,0,380.5,0,415v37c0,33.1,26.9,60,60,60h392c33.1,0,60-26.9,60-60v-37 C512,380.5,497.2,347.7,471.4,325z M148,148c0-59.6,48.4-108,108-108s108,48.4,108,108s-48.4,108-108,108S148,207.6,148,148z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg009User1);
export default __webpack_public_path__ + "static/media/009-user-1.487aac5a5c36ee7cf6fe38187d234350.svg";
export { ForwardRef as ReactComponent };